module.exports = __webpack_public_path__ + "img/emo_57.3e75a419.png";